import { useState } from 'react';
import axios from 'axios';
import { EmployeeSkillsByCategoryDTO } from '../models/SkillsInterfaces';

export const useGetEmployeeSkillById = () => {
  const [employeeSkillById, setEmployeeSkillById] =
    useState<EmployeeSkillsByCategoryDTO>();
  const [isLoadingEmployeeSkill, setIsLoadingEmployeeSkill] = useState(true);

  const getEmployeeSkillById = async (skillId: string) => {
    setIsLoadingEmployeeSkill(true);
    try {
      const response = await axios.get(`api/employee-skills/my/${skillId}`);
      setEmployeeSkillById(response.data);
    } catch (error) {
      console.error(error);
    }
    setIsLoadingEmployeeSkill(false);
  };

  return { employeeSkillById, getEmployeeSkillById, isLoadingEmployeeSkill };
};
